<template>
  <div>
    <q-form ref="form">
      <div class="row q-col-gutter-x-md">
        <div class="col-6">
          <q-input
            label="Emissions Factor"
            v-model="formData.emissionsFactor"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-input>
        </div>
        <div class="col-6">
          <q-input
            label="Unit"
            v-model="formData.unit"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-input>
        </div>
        <div class="col-6">
          <q-input label="Url" v-model="formData.url"> </q-input>
        </div>
        <div class="col-6">
          <Autocomplete
            label="Outcome"
            :id="formData.outcomes_id"
            :items="outcomes"
            :loading="outcomesLoading"
            @changed="(val) => (formData.outcomes_id = val)"
          ></Autocomplete>
          <!-- <q-input label="Blurb Override" v-model="formData.blurb"> </q-input> -->
        </div>
        <div class="col-6">
          <div class="row">
            <span> Scope </span>
          </div>
          <div class="row q-gutter-sm">
            <q-radio dense v-model="formData.scope" :val="1" label="1" />
            <q-radio dense v-model="formData.scope" :val="2" label="2" />
            <q-radio dense v-model="formData.scope" :val="3" label="3" />
          </div>
        </div>
        <div class="col-6">
          <q-checkbox
            label="Hide Blurb"
            v-model="formData.hideBlurb"
            :true-value="1"
            :false-value="0"
          >

          </q-checkbox>
        </div>
        <div class="col-12" v-if="!formData.hideBlurb">
          <q-input
            label="Blurb Override"
            type="textarea"
            v-model="formData.blurb"
          >
          </q-input>
        </div>
        <div class="col-12" v-if="!formData.hideBlurb">
          <div class="row">
            <span class="text-grey"> Text Preview </span>
          </div>
          <div class="row">
            <p class="text-preview" v-if="!formData.blurb">
              The emissions factor that we have used to determine your tCo2-e
              for this source was
              <strong>
                {{ formData.emissionsFactor }} {{ formData.unit }}</strong
              >. Based off the NZ government detailed emissions guide
              <a
                style="color: #162c47; font-weight: 800"
                target="_blank"
                :href="checkUrl(formData.url)"
                >found here</a
              >. <br />
              As at
              {{ formData.created_at | slashDate }}
            </p>
            <p v-else class="text-preview">
              {{ formData.blurb }}
              <a
                style="color: #162c47; font-weight: 800"
                target="_blank"
                :href="checkUrl(formData.url)"
                >found here</a
              >. <br />
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-end">
        <q-btn
          v-if="isCreate"
          color="primary"
          @click="create"
          class="float-right q-mt-sm"
          :loading="isLoading"
        >
          <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
          <span class="sustainability-font q-mx-sm" style="font-size: 13px">
            Create
          </span>
        </q-btn>
        <q-btn
          v-else
          color="primary"
          @click="save"
          class="float-right q-mt-sm"
          :loading="isLoading"
        >
          <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
          <span class="sustainability-font q-mx-sm" style="font-size: 13px">
            Save
          </span>
        </q-btn>
      </div>
    </q-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import Autocomplete from "@/components/autocomplete/autocomplete.vue";

  export default {
    data: () => ({
      formData: {
        unit: "kg CO2-e",
        emissionsFactor: null,
        url: "https://environment.govt.nz/publications/measuring-emissions-a-guide-for-organisations-2022-detailed-guide/",
        hideBlurb: 0
      },
      isCreate: true,
      isLoading: true,
    }),
    components: { Autocomplete },
    computed: {
      ...mapGetters({
        data: "sources/emissionsFactor/selectedReference",
        outcomes: "outcomes/list",
        outcomesLoading: "outcomes/listLoading",
      }),
    },
    mounted() {
      this.init();
    },
    methods: {
      checkUrl(url) {
        if (!url.includes("http")) {
          return "https://" + url;
        } else {
          return url;
        }
      },
      async init() {
        if (this.$route.params.hasOwnProperty("referenceID")) {
          await this.$store.dispatch(
            "sources/emissionsFactor/loadByID",
            this.$route.params.referenceID
          );

          this.formData = JSON.parse(JSON.stringify(this.data));
          this.isCreate = false;
        }
        this.isLoading = false;
      },
      async create() {
        const isValid = await this.$refs.form.validate();
        this.isLoading = true;
        if (isValid) {
          this.formData["sources_id"] = this.$route.params.id;
          let result = await this.$store.dispatch(
            "sources/emissionsFactor/new",
            this.formData
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            await this.$refs.form.reset();
            this.isLoading = false;
            this.closeForm();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
            this.isLoading = false;
          }
        }
      },
      async save() {
        const isValid = await this.$refs.form.validate();
        this.isLoading = true;
        if (isValid) {
          let result = await this.$store.dispatch(
            "sources/emissionsFactor/save",
            {
              ...this.formData,
            }
          );

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            await this.$refs.form.reset();
            this.isLoading = false;
            this.closeForm();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
            this.isLoading = false;
          }
        }
      },
      closeForm() {
        this.$emit("closeForm");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .text-preview {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    max-width: 245px;
  }
</style>
